import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { ViewboxGdprEffects } from './viewbox-gdpr.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ViewboxGdprEffects])],
})
export class ViewboxGdprDataModule {}
